import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("a", {
    href: $props.url,
    class: _normalizeClass(['gfu-tag-box', '_px-2', '_py-2', '_tdn', ...$options.classList]),
    role: "link",
    "aria-label": "Tag link"
  }, [
    _renderSlot(_ctx.$slots, "content")
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}